var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from '../framework/Timeouts';
export class ConvergePro2 {
    constructor(socket, log) {
        this.socket = socket;
        this.apiState = 'username';
        this.boxName = '128VTD_1';
        this.endpoints = [];
        this.locate = false;
        this.safetyMute = false;
        this.timeouts = new Timeouts();
        this.apiAsyncHandlers = [
            {
                regExp: /^BOX\s+(\S+)\s+DID/i,
                callback: (match) => {
                    if (match[1] === '*' || match[1] === this.boxName) {
                        this.socket.send(`BOX ${this.boxName} DID 1`);
                    }
                },
            },
            {
                regExp: /^EP\s+(\S+)\s+INQUIRE\s+ACTIVE_PARTIES/,
                callback: (match) => {
                    const ep = this.findEndpoint(match[1]);
                    if ((ep === null || ep === void 0 ? void 0 : ep.type) !== 'UA') {
                        this.sendError();
                        return;
                    }
                    const state = ep.hook ? `ACTIVE:${ep.callerId}` : 'IDLE';
                    const extra = ';IDLE;IDLE;IDLE;IDLE;';
                    this.socket.send(`EP ${ep.label} INQUIRE_RESULT ACTIVE_PARTIES ${state}${extra}`);
                },
            },
            {
                regExp: /^EP\s+(\S+)\s+INQUIRE\s+CALLER_ID/i,
                callback: (match) => {
                    const ep = this.findEndpoint(match[1]);
                    if ((ep === null || ep === void 0 ? void 0 : ep.type) === 'TELCO_RX' && (ep === null || ep === void 0 ? void 0 : ep.callerId) !== undefined) {
                        const value = !ep.hook || ep.callerId === '' ? 'NO_ACTIVE_CALL' : ep.callerId;
                        this.socket.send(`EP ${ep.label} INQUIRE CALLER_ID ${value}`);
                    }
                    else {
                        this.sendError();
                    }
                },
            },
            {
                regExp: /^EP\s+(\S+)\s+INQUIRE\s+DIRECTION/i,
                callback: (match) => {
                    const ep = this.findEndpoint(match[1]);
                    if ((ep === null || ep === void 0 ? void 0 : ep.direction) !== undefined) {
                        this.socket.send(`EP ${ep.label} INQUIRE DIRECTION ${ep.direction ? '1' : '0'}`);
                    }
                    else {
                        this.sendError();
                    }
                },
            },
            {
                regExp: /^EP\s+(\S+)\s+(?:INQUIRE\s+HOOK|KEY\s+KEY_HOOK\s+(0|1|2))/i,
                callback: (match) => {
                    const ep = this.findEndpoint(match[1]);
                    if (match[2] === undefined) {
                        if ((ep === null || ep === void 0 ? void 0 : ep.type) === 'TELCO_RX') {
                            this.sendHook(ep);
                        }
                        else {
                            this.sendError();
                        }
                    }
                    else {
                        if ((ep === null || ep === void 0 ? void 0 : ep.hook) === undefined) {
                            this.sendError();
                        }
                        else {
                            if (match[2] === '2') {
                                ep.hook = !ep.hook;
                            }
                            else if (match[2] === '1') {
                                ep.hook = true;
                            }
                            else {
                                ep.hook = false;
                            }
                            if (ep.hook) {
                                ep.offHookTime = Date.now();
                            }
                            else {
                                if (ep.type === 'TELCO_RX') {
                                    this.sendOffHookDuration(ep, 'NOTIFICATION CALL_DURATION');
                                }
                                ep.offHookTime = 0;
                            }
                            this.sendHook(ep, 'KEY KEY_HOOK');
                            if (ep.type === 'TELCO_RX') {
                                this.sendHook(ep, 'NOTIFICATION HOOK');
                            }
                            else {
                                if (ep.hook) {
                                    ep.callerId = '';
                                    const cmdStart = `EP ${ep.label} NOTIFICATION STATE_CHANGE PL 1;`;
                                    this.socket.send(`${cmdStart}IDLE`);
                                }
                            }
                        }
                    }
                },
            },
            {
                regExp: /^EP\s+(\S+)\s+INQUIRE\s+OFF_HOOK_DURATION/i,
                callback: (match) => {
                    const ep = this.findEndpoint(match[1]);
                    if ((ep === null || ep === void 0 ? void 0 : ep.type) === 'TELCO_RX') {
                        this.sendOffHookDuration(ep);
                    }
                    else {
                        this.sendError();
                    }
                },
            },
            {
                regExp: /^EP\s+(\S+)\s+INQUIRE\s+REG_STATUS/i,
                callback: (match) => {
                    const ep = this.findEndpoint(match[1]);
                    if ((ep === null || ep === void 0 ? void 0 : ep.type) === 'UA') {
                        this.socket.send(`EP ${ep.label} INQUIRE_RESULT REG_STATUS REGISTERED_PRIMARY`);
                    }
                    else {
                        this.sendError();
                    }
                },
            },
            {
                regExp: /^EP\s+(\S+)\s+KEY\s+KEY_CALL\s+(\S+)/,
                callback: (match) => {
                    const [, label, dialString] = match;
                    const ep = this.findEndpoint(label);
                    if (ep === undefined) {
                        this.sendError();
                    }
                    else {
                        this.socket.send(`EP ${ep.label} KEY KEY_CALL ${dialString}`);
                        if (!ep.hook) {
                            ep.hook = true;
                            if (ep.type === 'TELCO_RX') {
                                this.sendHook(ep, 'NOTIFICATION HOOK');
                            }
                            else if (ep.type === 'UA') {
                                ep.callerId = dialString;
                                const cmdStart = `EP ${ep.label} NOTIFICATION STATE_CHANGE PL 1;`;
                                this.socket.send(`${cmdStart}DIAL_TONE`);
                                this.socket.send(`${cmdStart}INPROCESS:${dialString}`);
                                this.socket.send(`${cmdStart}RINGING:${dialString}`);
                                this.socket.send(`${cmdStart}ACTIVE:${dialString}`);
                            }
                        }
                    }
                },
            },
            {
                regExp: /^EP\s+(\S+)\s+KEY\s+(KEY_DIGIT_PRESSED|KEY_DIGIT_RELEASED)\s+(\S+)/,
                callback: (match) => {
                    const ep = this.findEndpoint(match[1]);
                    if (ep === undefined) {
                        this.sendError();
                    }
                    else {
                        this.socket.send(`EP ${ep.label} KEY ${match[2]} ${match[3]}`);
                    }
                },
            },
            {
                regExp: /^BOX\s+(\S+)\s+LOCATE\s+ENABLE(?: (\S+))?/i,
                callback: (match) => {
                    if (match[1] === '*' || match[1] === this.boxName) {
                        let error = false;
                        if (match[2] !== undefined) {
                            if (match[2] === '0') {
                                this.locate = false;
                            }
                            else if (match[2] === '1') {
                                this.locate = true;
                            }
                            else {
                                error = true;
                            }
                        }
                        const value = error
                            ? `${match[2]} FAILED TO PROCESS COMMAND`
                            : this.locate
                                ? '1'
                                : '0';
                        this.socket.send(`EP ${this.boxName} LOCATE ENABLE ${value}`);
                    }
                },
            },
            {
                regExp: /^EP\s+(\S+)\s+(\d+)\s+LABEL/i,
                callback: (match) => {
                    const type = match[1].toUpperCase();
                    const id = parseInt(match[2]);
                    const ep = this.endpoints.find(ep => type === ep.type && id === 100 + ep.id);
                    const value = ep ? ep.label : `Error. Invalid EndPoint 1 ${match[2]}`;
                    this.socket.send(`EP ${type} ${match[2]} LABEL ${value}`);
                },
            },
            {
                regExp: /^EP\s+(\S+)\s+LEVEL\s+(GAIN_FINE|GAIN)(?:\s+(\S+))?/i,
                callback: (match) => {
                    const ep = this.findEndpoint(match[1]);
                    let error = true;
                    if (ep) {
                        if (match[2].toUpperCase() === 'GAIN') {
                            if (ep.gain !== undefined) {
                                if (match[3] !== undefined) {
                                    ep.gain = parseFloat(match[3]);
                                }
                                const value = ep.gain.toFixed(1);
                                this.socket.send(`EP ${ep.label} LEVEL GAIN ${value}`);
                                error = false;
                            }
                        }
                        else if (match[2].toUpperCase() === 'GAIN_FINE') {
                            if (ep.fineGain !== undefined) {
                                if (match[3] !== undefined) {
                                    ep.fineGain = parseFloat(match[3]);
                                }
                                const value = ep.fineGain.toFixed(1);
                                this.socket.send(`EP ${ep.label} LEVEL GAIN_FINE ${value}`);
                                error = false;
                            }
                        }
                    }
                    if (error)
                        this.sendError();
                },
            },
            {
                regExp: /^EP\s+(\S+)\s+LEVEL\s+MUTE(?:\s+(0|1|2))?/i,
                callback: (match) => {
                    const ep = this.findEndpoint(match[1]);
                    if (ep) {
                        if (match[2] !== undefined) {
                            if (match[2] === '2') {
                                ep.mute = !ep.mute;
                            }
                            else {
                                ep.mute = match[2] === '1';
                            }
                        }
                        this.socket.send(`EP ${ep.label} LEVEL MUTE ${ep.mute ? '1' : '0'}`);
                    }
                    else {
                        this.sendError();
                    }
                },
            },
            {
                regExp: /^MCCF\s+(\S+)/i,
                callback: (match) => {
                    this.socket.send(`MCCF ${match[1]}`);
                    // side effects?
                },
            },
            {
                regExp: /^STACK\s+SYSTEM\s+SFTYMUTE(?:\s+(\d+))?/i,
                callback: (match) => {
                    if (match[1] !== undefined) {
                        if (match[1] === '2') {
                            this.safetyMute = !this.safetyMute;
                        }
                        else {
                            this.safetyMute = match[1] === '1';
                        }
                    }
                    this.socket.send(`STACK SYSTEM SFTYMUTE ${this.safetyMute ? '1' : '0'}`);
                },
            },
            {
                regExp: /^VERSION\s+(\S+)\s+FW\s+1/i,
                callback: (match) => {
                    if (match[1] === '*' || match[1] === this.boxName) {
                        this.socket.send(`VERSION ${this.boxName} FW 1 8.2.12.0 "Fri 26 Mar 2021 09:27:43 AM MDT"`);
                    }
                },
            },
            {
                regExp: /.+/,
                callback: (match) => {
                    this.sendError();
                },
            },
        ];
        this.authAsyncHandlers = [
            {
                regExp: /.+/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    if (this.apiState === 'username') {
                        this.apiState = 'password';
                        this.socket.sendRaw(`Password: `);
                        // Delay allows emulator to ignore the empty password and respond to allow the
                        // driver to continue connecting.
                        yield this.timeouts.delay(500);
                        this.apiState = 'authenticated';
                        this.socket.send(`=> `);
                        this.asyncHandlers = this.apiAsyncHandlers;
                    }
                }),
            },
        ];
        this.asyncHandlers = this.authAsyncHandlers;
        this.sendTerminator = '\r\n=> ';
    }
    onInitialize() {
        return __awaiter(this, void 0, void 0, function* () {
            this.apiState = 'username';
            this.asyncHandlers = this.authAsyncHandlers;
            yield this.timeouts.delay(1000);
            this.socket.sendRaw(`Username: `);
        });
    }
    onConfigure(config) {
        if (this.endpoints.length === 0) {
            if ((config === null || config === void 0 ? void 0 : config.equipmentType) === '-L6vr3WoJJpmHv3vubko') {
                this.initializePro2();
            }
            else {
                this.initializeHuddle();
            }
        }
    }
    findEndpoint(label) {
        return this.endpoints.find(ep => ep.label === label);
    }
    initializeHuddle() {
        this.boxName = 'CONVERGE_Huddle';
        this.endpoints.push({ gain: 0, id: 1, label: `BT_L_RX`, mute: false, type: 'BTE_RX' });
        this.endpoints.push({ gain: 0, id: 2, label: `BT_R_Rx`, mute: false, type: 'BTE_RX' });
        this.endpoints.push({ gain: 0, id: 1, label: `BT_Tx`, mute: false, type: 'BTE_TX' });
        this.endpoints.push({ gain: 0, id: 1, label: `BMA_CTH`, mute: false, type: 'CTHBFM' });
        for (let i = 0; i < 2; i++) {
            this.endpoints.push({
                gain: 0,
                id: i + 1,
                label: `BMA_CTH_Speaker${i + 1}`,
                mute: false,
                type: 'CTHBFM_SPKR',
            });
        }
        for (let i = 0; i < 3; i++) {
            this.endpoints.push({
                fineGain: 0,
                gain: 0,
                id: i + 1,
                label: `Mic${i + 1}`,
                mute: false,
                type: 'MIC',
            });
        }
        this.endpoints.push({ gain: 0, id: 1, label: `LineInput`, mute: false, type: 'INPUT' });
        this.endpoints.push({
            gain: 0,
            id: 1,
            label: `Mobile_L_Rx`,
            mute: false,
            type: 'MOBILE_RX',
        });
        this.endpoints.push({
            gain: 0,
            id: 2,
            label: `Mobile_R_Rx`,
            mute: false,
            type: 'MOBILE_RX',
        });
        this.endpoints.push({
            gain: 0,
            id: 1,
            label: `Mobile_Tx`,
            mute: false,
            type: 'MOBILE_TX',
        });
        for (let i = 0; i < 2; i++) {
            this.endpoints.push({
                gain: 0,
                id: i + 1,
                label: `Output${i + 1}`,
                mute: false,
                type: 'OUTPUT',
            });
        }
        for (let i = 0; i < 2; i++) {
            this.endpoints.push({
                gain: 0,
                id: i + 1,
                label: `ProcBlk${i + 1}`,
                mute: false,
                type: 'PROC',
            });
        }
        for (let i = 0; i < 2; i++) {
            this.endpoints.push({
                gain: 0,
                id: i + 1,
                label: `Speaker${i + 1}`,
                mute: false,
                type: 'SPEAKER',
            });
        }
        this.endpoints.push({ gain: 0, id: 1, label: `USB_L_Rx`, mute: false, type: 'USB_RX' });
        this.endpoints.push({ gain: 0, id: 2, label: `USB_R_Rx`, mute: false, type: 'USB_RX' });
        this.endpoints.push({ gain: 0, id: 1, label: `USB_L_Tx`, mute: false, type: 'USB_TX' });
        this.endpoints.push({ gain: 0, id: 2, label: `USB_R_Tx`, mute: false, type: 'USB_TX' });
    }
    initializePro2() {
        this.boxName = '128VTD_1';
        for (let i = 0; i < 8; i++) {
            this.endpoints.push({
                gain: 0,
                id: i + 1,
                label: `Fader${i + 1}`,
                mute: false,
                type: 'FADER',
            });
        }
        for (let i = 0; i < 12; i++) {
            this.endpoints.push({
                fineGain: 0,
                gain: 0,
                id: i + 1,
                label: `Mic${i + 1}`,
                mute: false,
                type: 'MIC',
            });
        }
        for (let i = 0; i < 8; i++) {
            this.endpoints.push({
                gain: 0,
                id: i + 1,
                label: `Output${i + 1}`,
                mute: false,
                type: 'OUTPUT',
            });
        }
        for (let i = 0; i < 8; i++) {
            this.endpoints.push({
                gain: 0,
                id: i + 1,
                label: `Proc${i + 1}`,
                mute: false,
                type: 'PROC',
            });
        }
        this.endpoints.push({
            callerId: '',
            direction: false,
            gain: 0,
            hook: false,
            id: 1,
            label: `Telco1_Rx`,
            mute: false,
            offHookTime: 0,
            type: 'TELCO_RX',
        });
        this.endpoints.push({ gain: 0, id: 1, label: `UsbRx`, mute: false, type: 'USB_RX' });
        this.endpoints.push({ gain: 0, id: 1, label: `UsbTx`, mute: false, type: 'USB_TX' });
        for (let i = 0; i < 5; i++) {
            this.endpoints.push({
                callerId: '',
                hook: false,
                id: i + 1,
                label: `Voip${i + 1}`,
                offHookTime: 0,
                type: 'UA',
            });
            this.endpoints.push({
                gain: 0,
                id: i + 1,
                label: `Voip${i + 1}_Rx`,
                mute: false,
                type: 'VOIP_RX',
            });
        }
    }
    sendError() {
        this.socket.send(`Error Invalid Parameter(s)`);
    }
    sendHook(ep, params = 'INQUIRE HOOK') {
        if ((ep === null || ep === void 0 ? void 0 : ep.hook) !== undefined) {
            this.socket.send(`EP ${ep.label} ${params} ${ep.hook ? '1' : '0'}`);
        }
        else {
            this.sendError();
        }
    }
    sendOffHookDuration(ep, params = 'INQUIRE OFF_HOOK_DURATION') {
        if ((ep === null || ep === void 0 ? void 0 : ep.offHookTime) !== undefined) {
            const duration = (ep.offHookTime > 0
                ? (Date.now() - ep.offHookTime) / 1000
                : 0).toFixed(0);
            this.socket.send(`EP ${ep.label} ${params} ${duration}`);
        }
        else {
            this.sendError();
        }
    }
}
ConvergePro2.emulatorType = 'socketEmulator';
ConvergePro2.key = '-L6vr3WoJJpmHv3vubko';
